export interface MaterialIcon {
  name: string;
  version: number;
  popularity: number;
  codepoint: number;
  unsupported_families: Array<string>;
  categories: Array<string>;
  tags: Array<string>;
  sizes_px: Array<number>;
  display: string;
}

export enum MediaCategory {
  Photos = 'photos',
  Graphics = 'graphics',
  Icons = 'icons',
  Videos = 'videos',
}

export interface MediaUploadSettings {
  success: boolean;
  category: MediaCategory;
  collection: string;
  uploadResult?: unknown;
  error?: unknown;
}

export interface MediaModel {
  uri: string;
  lastModified: any;
  filename: string;
  readable: string;
  category: MediaCategory;
  collection?: MediaCollection;
  url: string;
  style: any;
  loading: boolean;
  triggerbeeImage: boolean;
}

export interface MediaFileWithProcessing {
  file: File;
  mediaProcessingType: MediaProcessingType;
}

export enum MediaProcessingType {
  Original = 'imageOriginal',
  Resized = 'imageResized',
  MaxSized = 'imageMaxSized',
  Video = 'videoOriginal',
}

export interface AddCollectionEvent {
  category: MediaCategory;
  collection: MediaCollection;
}

export enum MediaUpdateType {
  Add = 'add',
  Remove = 'remove',
  Update = 'update',
  FirstFetch = 'firstFetch',
}

export interface MediaFilesUpdate {
  mediaFiles: MediaModel[];
  reason: MediaUpdateType;
}

export interface MediaCollection {
  name: string;
  isTriggerbee: boolean;
}

export interface CurrentlySelectedCollection {
  category: MediaCategory;
  collection: string;
}
